import CardBenefitsScreen from 'features/believe/learningCenter/CardBenefitsScreen/CardBenefitsScreen';
import React from 'react';

export default function Page() {
  return <CardBenefitsScreen />;
}
